import { apiRequest } from './client';
import type { DocumentSummary, DocumentUpdateRequest } from './types';

export async function listDocuments(): Promise<DocumentSummary[]> {
  return apiRequest<DocumentSummary[]>('/documents');
}

export async function uploadDocument(
  file: File,
  description?: string,
): Promise<DocumentSummary> {
  const formData = new FormData();
  formData.append('file', file);
  if (description) formData.append('description', description);
  return apiRequest<DocumentSummary>('/documents', { method: 'POST', formData });
}

export function documentFileUrl(id: number): string {
  return `/api/v1/documents/${id}/file`;
}

export async function updateDocument(
  id: number,
  description: string | null,
): Promise<DocumentSummary> {
  const body: DocumentUpdateRequest = { description };
  return apiRequest<DocumentSummary>(`/documents/${id}`, { method: 'PATCH', body });
}

export async function deleteDocument(id: number): Promise<void> {
  await apiRequest(`/documents/${id}`, { method: 'DELETE' });
}
